import { render, staticRenderFns } from "./CanceledOrderCard.html?vue&type=template&id=e467d7ea&scoped=true&"
import script from "./CanceledOrderCard.js?vue&type=script&lang=js&"
export * from "./CanceledOrderCard.js?vue&type=script&lang=js&"
import style0 from "./CanceledOrderCard.scss?vue&type=style&index=0&id=e467d7ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e467d7ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VIcon})
